module.exports = __webpack_public_path__ + "img/20.71d7c645.png";